import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function WorkOrdersPage() {
  return (
    <MainLayout>
      <SEO 
        title="Ordens de serviço"
        description="Gerencie ordens de serviço"
        keywords="ordens de serviço, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Ordens de serviço</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

